<template>
  <div class='h100-60 noPage'>
    <ejs-grid ref='grid' height='calc(100% - 80px)' :rowSelected="watchRowSelected" :rowDeselected='watchRowDeSelected'></ejs-grid>
  </div>
</template>

<script>
import DetailTemplate from '../deployedInstance/DetailTemplate';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'Table',
  props: [
    'qryParam',
    'rowSelectedflag'
  ],
  data() {
    return {
      instanceColumns: [
        { field: 'runState', headerText: `${this.$t('DeployManagement.deployedStatus')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'serviceName', headerText: `${this.$t('Alarm.neType')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'dname', headerText: `${this.$t('DeployManagement.neName')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'deliverTypeStr', headerText: `${this.$t('DeployManagement.deliverTypeStr')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'version', headerText:`${this.$t('DeployManagement.version')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText:  `${this.$t('DeployManagement.createTime')}`, clipMode: 'EllipsisWithTooltip', format: 'yyyy-MM-dd HH:mm:ss', type: 'date', textAlign: 'Center' },
        // { field: 'nodeName', headerText: `${this.$t('DeployManagement.nodeName')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'runEnvironment', headerText: `${this.$t('DeployManagement.runEnvironment')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'idFlag', headerText: `${this.$t('DeployManagement.operate')}`,textAlign: 'Center', clipMode: 'EllipsisWithTooltip', template: this.detailTemplate },
        { field: 'id', textAlign: 'Center', clipMode: 'EllipsisWithTooltip', isPrimaryKey: true, visible: false },
      ],
      versionColumns: [
        { field: 'serviceName', headerText: `${this.$t('Alarm.neType')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        /*{ field: 'type', headerText: `${this.$t('DeployManagement.classify')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },*/
        { field: 'deployedCount', headerText: `${this.$t('DeployManagement.deployTotal')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: `${this.$t('DeployManagement.lunchTime')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'idFlag', headerText: `${this.$t('DeployManagement.operate')}`,textAlign: 'Center', clipMode: 'EllipsisWithTooltip', template: this.detailTemplate },
        { field: 'status', headerText: `${this.$t('DeployManagement.uploadStatus')}`, textAlign: 'Center', clipMode: 'EllipsisWithTooltip' },
      ],
      instanceColumnsInner: [
        { field: 'runState', headerText: `${this.$t('DeployManagement.runStatus')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'dname', headerText: `${this.$t('DeployManagement.neName')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'deliverTypeStr', headerText: `${this.$t('DeployManagement.deliverTypeStr')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'version', headerText: `${this.$t('DeployManagement.version')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: `${this.$t('DeployManagement.createTime')}`, clipMode: 'EllipsisWithTooltip', format: 'yyyy-MM-dd HH:mm:ss', type: 'date', textAlign: 'Center' },
        // { field: 'nodeName', headerText: `${this.$t('DeployManagement.nodeName')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'runEnvironment', headerText: `${this.$t('DeployManagement.runEnvironment')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'id', headerText: `${this.$t('DeployManagement.nodeID')}`, textAlign: 'Center', clipMode: 'EllipsisWithTooltip', template: this.detailTemplate, isPrimaryKey: true, visible: false },
      ],
      versionColumnsInner: [
        { field: 'deliverType', headerText: `${this.$t('DeployManagement.deliverTypeStr')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'pkgVersion', headerText: `${this.$t('DeployManagement.version')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'deployedCount', headerText: `${this.$t('DeployManagement.deployCount')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'exist', headerText: `${this.$t('DeployManagement.hasPkg')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: `${this.$t('DeployManagement.createTime')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
      ],
      versionColumnsInnerNew: [
        { field: 'deliverType', headerText: `${this.$t('DeployManagement.deliverTypeStr')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'pkgVersion', headerText: `${this.$t('DeployManagement.version')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'exist', headerText: `${this.$t('DeployManagement.hasPkg')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'createTime', headerText: `${this.$t('DeployManagement.createTime')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
      ],
      nodeColumnsInner: [
        { field: 'k8sNodeId', headerText: `${this.$t('DeployManagement.nodeID')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'service', headerText: `${this.$t('DeployManagement.nodeType')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'name', headerText: `${this.$t('DeployManagement.nodeName')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
        { field: 'description', headerText: `${this.$t('DeployManagement.nodeDesc')}`, clipMode: 'EllipsisWithTooltip', textAlign: 'Center' },
      ],
      oamTypeCode: 0,
      columnsMap: {
        0: this.instanceColumns,
        1: this.versionColumns,
        2: this.instanceColumnsInner,
        3: this.versionColumnsInner,
        4: this.nodeColumnsInner,
        5: this.versionColumnsInnerNew,
      },
      neMap: {
        0: this.$t('System.neOAM'),
        3: this.$t('Topo.neMME'),
        4: this.$t('Topo.neHSS'),
        5: this.$t('Topo.nePGW'),
        6: this.$t('Topo.neSGW'),
        7: this.$t('Topo.nePCRF'),
        8: this.$t('Topo.neTCF'),
        9: this.$t('Topo.neTMF'),
        10: this.$t('Topo.nePDTGW'),
        11: this.$t('Topo.neDBS'),
        12: this.$t('Topo.neMC_CMS'),
        13: this.$t('Topo.neMC_CF'),
        14: this.$t('Topo.neMC_GMS'),
        15: this.$t('Topo.neMC_IDMS'),
        16: this.$t('Topo.neMC_PF'),
        17: this.$t('Topo.neBM_SC'),
        18: this.$t('Topo.neMBMS_GW'),
        19: this.$t('Topo.neFRS'),
        20: this.$t('Topo.neMC_TMF'),
        21: this.$t('Topo.nePRES'),
        23: this.$t('Topo.neP_HSS'),
        24: this.$t('Topo.neMC_KMS'),
        27: this.$t('Topo.neMCE'),
        28: this.$t('Topo.nePCDR'),
        31: this.$t('Topo.neDMS'),
        34: this.$t('Topo.neMC_GMS_NODE'),
        100: this.$t('Topo.neCU'),
        101: this.$t('Topo.neDU'),
        102: this.$t('Topo.neCU'),
        103: this.$t('Topo.neDU'),
        10001: this.$t('System.epcOAM'),
        10002: this.$t('System.imsOAM'),
        10003: this.$t('System.mcsOAM'),
        10004: this.$t('System.enodeb'),
        10006: 'iBS',
        10007: this.$t('System.ibs_b'),
        10010: this.$t('System.ims_hytalk'),
        20001: this.$t('System.mcscl'),
        10009: this.$t('Topo.devgNB'),
        30000: 'AMF',
        //  poc微服务---- 服务类型2100-2165
        2100:  "ETCD",
        2101: "RABBITMQ",
        2102: "REDIS",
        2103: "NGINX",
        2104: "PG",
        2105: "EFK",
        2106: "CP",
        2107: "MGW",
        2108: "MS",
        2109: "NRS",
        2110: "CMS",
        2111: "WP",
        2112: "CDWGW",
        2113: "AFFA",
        2114: "FLOOR",
        2115: "GC",
        2116: "GDM",
        2117: "MSFS",
        2118: "PC",
        2119: "PNASC",
        2120: "PNASGW",
        2121: "SIPGW",
        2122: "SIPLBS",
        2123: "UDM",
        2124: "MYSQL",
        2125: "RMQ",
        2126: "DP",
        2127: "SIPC",
        2128: "DMC",
        2129: "USP",
        2130: "PUCP",
        2131: "PDTP",
        2132: "ACS",
        2133: "SDS",
        2134: "INC",
        2135: "REG",
        2136: "SUB",
        2137: "EMBMS",
        2138: "LOC",
        2139:"PDTGW",
        2140:"SDSS",
        2141: "PRES",
        2142: "GMS",
        2143: "IDMS",
        2144: "KMS",
        2145: "FRS",
        2146: "DMS",
        2147: "GMKMS",
        2148: "CDWDB",
        2149: "DBS",
        2150: "UDU",
        2151: "SIPAAS",
        2152: "SIPNS",
        2153: "DIES",
        2154: "DSS",
        2155: "DST",
        2156:"TMPF",
        2157: "ESI",
        2158: "ESO",
        2159: "GRAF",
        2160: "KBN",
        2161: "NRM",
        2162: "SIPNSPF",
        2163: "SIPNSCF",
        2164: "SIPNSCMS",
        2165: "SIPNSGMS",
        // D项目
        41: "UPF",
        42: "NSSF",
        39: "PCF",
        36: "UDM",
        40: "AUSF",
        37: "AMF",
        38: "SMF",
        43: "HSS",
        44: "PCSCF",
        45: "ICSCF",
        46: "SCSCF",
        47: "MRF",
        48: "MMTELAS",
        49: "NRF",
        255: "VDOS",
        253: "OAM_5GC",
        254: "OAM_IMS",
      },
      neType: {
        0: this.$t('DeployManagement.serviceType_base'),
        1: this.$t('DeployManagement.serviceType_ser')
      },
      deliverMap: { // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: 'Native',
        1: 'Image',
        2: 'Helm',
        3: 'Vm'
      },
      envirMap: {
        1: 'DP',
        2: 'k8s',
        3: 'server',
        4: 'device'
      },
      existMap: {
        0: this.$t('DeployManagement.exist'),
        1: this.$t('DeployManagement.notExist')
      },
      runstateMap: { // 0-2 DP运行状态  ---待补充5g运行状态
        0: this.$t('DeployManagement.unDeploy'),
        1: this.$t('DeployManagement.unRun'),
        2: this.$t('DeployManagement.runing'),
        20:this.$t('DeployManagement.unDeploy'),
        21: this.$t('DeployManagement.unRun'),
        22: this.$t('DeployManagement.runing'),
        100: this.$t('DeployManagement.connected'), // old网元的运行状态
      },
      runstate5gMap: { // 0-2 DP运行状态
        0: this.$t('DeployManagement.deployFailure'),
        1: this.$t('DeployManagement.deploying'),
        2: this.$t('DeployManagement.deployed'),
        10: this.$t('DeployManagement.deployFailure'),
        11: this.$t('DeployManagement.deploying'),
        12: this.$t('DeployManagement.deployed'),
      },
      url: '/lte/ems/',
      param: {

      },
      stateQryTypeMap: new Map(),
      query5GCRunStateTimer: undefined,
      queryDPRunStateTimer: undefined,
      queryAllRunStateTimer: undefined,
      adapterData:[]
    };
  },
  methods: {
    freshServerList(typeCode = undefined, deliverType = undefined) {
      if (typeCode) {
        const qryParam = { oamTypeCode: typeCode, deliverType: deliverType};
        const obj = this.$refs.grid.ej2Instances;
        obj.columns = this.versionColumnsInner;
        this.getServiceList(qryParam, `${this.url}packageManager/queryServiceAll`);
      }
    },
    init(index, unDeployedList, target = undefined) {
      const { qryParam } = this;
      // 0-已部署实例（所有） 1-所有版本 2-指定产品或网元的已部署实例 3-指定产品或网元的服务列表
      const obj = this.$refs.grid.ej2Instances;
      if (index === 0) {
        obj.columns = this.instanceColumns;
        this.getInstanceList(qryParam, `${this.url}deployed/queryDeployedInfoAll`);
      } else if (index === 1) {
        obj.columns = this.versionColumns;
        this.getServiceList(qryParam, `${this.url}packageManager/queryServiceAll`);
      } else if (index === 2) {
        obj.columns = this.instanceColumnsInner;
        this.getInstanceList(qryParam, `${this.url}deployed/queryDeployedInfoAll`);
      } else if (index === 3) {
        //添加某些类型不显示部署数量
        // if(unDeployedList != null && unDeployedList.findIndex(item => item === qryParam['oamTypeCode']) >= 0 ){
        //   obj.columns = this.versionColumnsInnerNew;
        // }else{
        //   obj.columns = this.versionColumnsInner;
        // } //调整了适配包的显示，去掉了上面部分，直接显示明细
        obj.columns = this.versionColumnsInnerNew;
        const  qryParamDe={
          deliverType : 0,
          oamTypeCode :10004,
          version:""
        }
        this.getServiceList(qryParamDe, `${this.url}packageManager/queryServiceAll`);
      } else if (index === 4) {
        obj.columns = this.nodeColumnsInner;
        this.getNodeList(qryParam, `${this.url}deployed/qryNodeList`);

      }
    },
    handlerServerResult(res) {
      const result = res.data;
      const showRe = [];
      if (result) {
        //oamtypecode不等于-1------暂时前端做过滤，后续设备侧oam和到服务中不会出现此问题
        const resultLast = result.filter((item) =>
          item.oamTypeCode !== -1
        );
        const detailOperate = this.$t('DeployManagement.detail');
        resultLast.forEach(item => {
          const re = {};
          re.deliverTypeId = item.deliverType;
          re.deliverType = this.deliverMap[item.deliverType];
          re.serviceName = this.neMap[item.oamTypeCode];
          re.serviceId = item.oamTypeCode;
          re.introduction = '';
          re.type = this.neType[item.opType];
          re.instanceNum = '';
          re.createTime = item.createTime;
          re.deployedCount = item.deployedCount;
          re.idFlag = `0_${item.oamTypeCode}`;
          re.deleteFlag = true;
          re.status = item.status;
          re.operateTitle = detailOperate;
          showRe.push(re);
        });
        this.dataBak = showRe;
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.data = showRe;
        EventBus.$emit('initTotalNum', { totalCount: showRe.length });
      }
    },
    handlerInstanceResult(res, qryParam = undefined) {
      // res.push({ dname: '123', deliverType: 1, version: '22222222', runEnvironment: 'dptest', oamTypeCode: '20', createTime: 1454545452000, envID: 1, envType: 'DP', dpId: '11111111', envId: '' });
      // res.push({ dname: '222', deliverType: 2, version: '33333333', runEnvironment: '5GCTEST', oamTypeCode: '20', createTime: 1454545452000, envID: 2, envType: '5G', dpId: '11111112', envId: '655e9ef9044344ba9e8d0567dacca258' });
      // res.push({ dname: '333', deliverType: 0, version: '12122122', runEnvironment: 'native_server', oamTypeCode: '12', createTime: 1454545452000, envID: 3, envType: '', dpId: '' });
      // res.push({ dname: '4444', deliverType: 0, version: '3243434', runEnvironment: 'native_server', oamTypeCode: '13', createTime: 1454545452000, envID: 3, envType: '', dpId: '' });
      // res.push({ dname: 'aaa', deliverType: 1, version: 'aaa2222', runEnvironment: 'dptest1', oamTypeCode: '21', createTime: 1454545422000, envID: 1, envType: 'DP', dpId: '11111113' });
      // res.push({ dname: 'bbb', deliverType: 2, version: 'bbb3333', runEnvironment: '5GCTEST1', oamTypeCode: '21', createTime: 1454545422000, envID: 2, envType: '5G', dpId: '11111114' });
      const result = res;
      const showRe = [];
      // if (qryParam) { // 查询参数不为空
      //   this.queryDeployedState(queryParam);
      // }
      const detailOperate = this.$t('DeployManagement.detail');
      result.forEach(item => {
        const re = item;
        re.operateTitle = detailOperate;
        re.serviceId = item.oamTypeCode;
        re.serviceName = this.neMap[item.oamTypeCode];
        re.createTime = parseInt(re.createTime, 10);
        re.runEnvironmentId = item.envID;
        // re.runEnvironment = this.envirMap[re.runEnvironmentId]
        re.deliverTypeStr = this.deliverMap[item.deliverType];
        if (item.deliverType === 0) {
          re.runState = this.runstateMap[100];
          re.runStateValue = 100;
        } else {
          // re.runState = '----';
          if (!this.stateQryTypeMap.get(re.envType)) {
            this.stateQryTypeMap.set(re.envType, true);
          }
          re.runStateValue = item.runState;
          switch(item.deliverType) {
            case 1:
              re.runState = this.runstateMap[item.runState]?this.runstateMap[item.runState]:'----';
              break;
            case 2:
              re.runState = this.runstate5gMap[item.runState]?this.runstate5gMap[item.runState]:'----';
              break;
          }
          // poc微服务--- 轮询查询？  ---更新运行状态
          // d项目 --- 轮询查询？ ---更新运行状态
          // const state = '1';
        }
        re.idFlag = `1_${item.oamTypeCode}`;
        re.deleteFlag = false;
        showRe.push(re);
      });
      this.$refs.grid.ej2Instances.dataSource = showRe;
      this.dataBak = showRe;
      this.data = showRe;
      EventBus.$emit('deployedProgressInfo', showRe, this.qryParam?this.qryParam.envID:this.qryParam, this.$refs.grid.ej2Instances.dataSource.length, 1);

      this.queryDeployedState(qryParam);
    },
    getInstanceList(qryParam = undefined, url) {
      // TODO 运行状态查询
      const param = {};
      // qryParam = {};
      // qryParam.oamTypeCode = undefined;
      // qryParam.envID = 'd2ec0facc16841fe91560dc358af01de';
      if (qryParam) {
        if (qryParam.oamTypeCode) {
          url = `${url}?oamTypeCode=${qryParam.oamTypeCode}`;
        } else if (qryParam.envID) {
          url = `${url}?envID=${qryParam.envID}`;
        }
      }
      this.axios.get(url, param).then(res => {
        this.handlerInstanceResult(res.data.resultVal, qryParam);
      });
    },
    initDataCallFun(res) {
      const $this = this;
      $this.$refs.grid.ej2Instances.dataSource = res;
      $this.data = res;
    },
    getNodeList(qryParam = undefined, url) {
      const param = {
        envID: this.qryParam.envID
      };
      // 查询所有node节点----根据环境
      this.$axios.post(url, param).then((res) => {
        if (res.data && res.data.resultVal) {
          this.$refs.grid.ej2Instances.dataSource = res.data.resultVal;
        }
      });
    },
    getServiceList(qryParam = undefined, url) {
      console.log( qryParam);
      if (qryParam) {
        url = `${url}?oamTypeCode=${qryParam.oamTypeCode}`;
      }
      this.axios.get(url).then(res => {
        const result = res.data;
        const showRe = [];
        let showReHasPkg = [];
        if (qryParam === undefined) {
          this.handlerServerResult(res);
        } else {
          const urlNew = `/lte/ems/packageManager/findUpBackPackage?oamTypeCode=${qryParam.oamTypeCode}&deliverType=${qryParam.deliverType}`;
          // 查询是否存在软件包
          this.axios.get(urlNew).then(res => {
            this.adapterData  =  res.data;
            showReHasPkg = this.handlerPkgPackage(res.data);
            const detailOperate = this.$t('DeployManagement.detail');
            result.forEach((item, index) => {
              const re = item;
              // console.log("baseItem",item);
              // console.log("showReHasPkg", showReHasPkg);
              re.deliverTypeId = item.deliverType;
              re.deliverType = this.deliverMap[item.deliverType];
              re.serviceName = this.neMap[item.oamTypeCode];
              re.deployedCount = item.deployedCount;
              re.serviceId = item.oamTypeCode;
              re.deleteFlag = true;
              re.operateTitle = detailOperate;
              const reHasPkg = showReHasPkg.filter(item => item.deliverVersion == re.pkgVersion);
              // console.log("reHasPkg", reHasPkg);
              re.existNum = reHasPkg[0]?reHasPkg[0].existNum:1;
              re.chartPath = reHasPkg[0]?reHasPkg[0].chartPath:'';
              re.configPath = reHasPkg[0]?reHasPkg[0].configPath:'';
              re.exist = this.existMap[re.existNum];
              re.packageName = res.data;
              showRe.push(re);
            });
            // console.log("------------------showRe", showRe);
            this.dataBak = showRe;
            this.$refs.grid.ej2Instances.dataSource = showRe;
            this.data = showRe;
            EventBus.$emit('curAdapterList', this.adapterData);
            EventBus.$emit('updateTotalNum', { deployedNum: 0, versionNum: showRe.length });
          });
        }
      });
    },
    getDataListSize(){
      return this.$refs.grid.ej2Instances.dataSource.length;
    },
    detailTemplate() {
      return {
        template: DetailTemplate
      };
    },
    // grid行选择
    watchRowSelected() {
      if (this.rowSelectedflag) {
        console.log('--------------', this.$refs.grid.getSelectedRecords());
        EventBus.$emit('updateDetail', this.$refs.grid.getSelectedRecords()[0]);
      }
    },
    watchRowDeSelected() {
      if (this.rowSelectedflag && this.$refs.grid.getSelectedRecords().length === 0) {
        EventBus.$emit('updateInitDetail');
      }
    },
    getParam() {
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record.length === 0) {
        this.$parent.showToast('warning', `${this.$t('System.selectDelObj')}`);
        return null;
      }
      return record;
    },
    // 判断是否存在软件包
    handlerPkgPackage(result) {
      const adapter = result.filter(item => item.pkgType === 0);
      const pkg = result.filter(item => item.pkgType === 1).map(item => {
        const { pkgName, pkgVersion } = item;
        return {
          pkgName,
          pkgVersion
        };
      });
      const serverPkg = result.filter(item => item.pkgType === 2).map(item => {
        const { packageName, pkgVersion } = item;
        return {
          packageName,
          pkgVersion
        };
      });
      const chartConfig = result.filter(item => item.pkgType === 3).map(item => {
        const { packageName, pkgVersion, chartPath, configPath } = item;
        return {
          packageName,
          pkgVersion,
          chartPath,
          configPath
        };
      });
      const showRe = [];
      adapter.forEach(item => {
        const re = { upVersion: [] };
        re.deliverType = item.deliverType;
        re.deliverName = this.deliverMap[item.deliverType];
        re.deliverVersion = item.pkgVersion;
        const tempN = pkg.filter(it => it.pkgName === item.pkgName);
        const tempS = serverPkg.filter(it => it.packageName === item.packageName);
        const tempConfig = chartConfig.filter(it => it.packageName === item.packageName);
        if (Object.keys(tempN).length === 1) {
          // native 类型，检查是否存在升级包pkg(2个)
          re.existNum = 0;
          re.pkgType = 1;
          re.upVersion = tempN.map(re => re.pkgVersion);
        } else if (Object.keys(tempS).length === 1) {
          // image/helm类型，检查是否存在软件包
          re.existNum = 0;
          re.pkgType = 2;
          re.upVersion = tempS.map(re => re.pkgVersion);
        } else {
          re.existNum = 1;
        }
        if (Object.keys(tempConfig).length === 1) {
          // chart，检查是否存在软件包
          re.existNum = 0;
          re.chartPath = tempConfig.map(re => re.chartPath)[0];
          re.configPath = tempConfig.map(re => re.configPath)[0];
        }
        re.exist = this.existMap[re.existNum];
        showRe.push(re);
      });
      return showRe;
    },
    /**
     * 查询已部署实例的运行状态(D项目、微服务)
     * @infoMap
     * 微服务查询单个需要的参数id（拓扑id）
     * D项目待定
     * typeCode和deliverType组合--后台根据参数判断给哪个产品下发
     */
    queryDeployedState(qryParam = {}) {
      // console.log(qryParam, this.data);
      const url = `${this.url}deployed/queryDeployedState`;
      const qryFlag = Array.from(this.stateQryTypeMap);
      if (qryFlag.length > 0) { // 查所有或查询D或POC微服务
          this.queryAllRunStateTimer = setInterval(
            this.queryAllDeployedState
          , 15000);
        // if (qryFlag.length === 2) {
        //   // infoMap.set('flag', 'all'); // 给两个产品下发任务---或分别下发查询请求
        //   this.queryAllRunStateTimer = setInterval(() => {
        //     this.query5GCDeployedState(qryParam);
        //     this.queryDPDeployedState(qryParam);
        //   }, 32000);
        // } else if (qryFlag[0][0] === '5G') {
        //   // infoMap.set('flag', qryFlag[0]); // 具体产品类型---5G 或 DP
        //   this.query5GCRunStateTimer = setInterval(() => {
        //     this.query5GCDeployedState(qryParam);
        //   }, 32000);
        // } else if (qryFlag[0][0] === 'DP') {
        //   this.queryDPRunStateTimer = setInterval(() => {
        //     this.queryDPDeployedState(qryParam);
        //   }, 32000);
        // }
        this.stateQryTypeMap = new Map();
      }
    },
    queryAllDeployedState() {
      const infoMap = new Map();
      const url = `${this.url}deployed/queryDeployedState`;
      this.axios.post(url, infoMap).then(res => {
        const value = this.handlerResponse(res);
        this.handlerMergeResult(value);
      });
    },
    /**
     * 查询微服务已部署实例的运行状态
     * 微服务查询单个需要的参数id（拓扑id）
     */
    queryDPDeployedState(qryParam = undefined) {
      const infoMap = new Map();
      infoMap.set('operation', 'dp/serviceMng/getdeployProgressInfo');
      infoMap.set('jsonParam', {});
      const url = `${this.url}deployed/queryDPDeployedState`;
      this.axios.post(url, infoMap).then(res => {
        // 返回结果status,错误码；data:List<ServiceDeployStatus>
        // id节点id,  dpId
        // status节点状态，status
        // hasDeploy是否执行了部署动作-------与5gc合并
        const value = this.handlerResponse(res);
        // const valueT = [{ id: '11111111', status: 1 }, { id: '11111113', status: 0 }];
        // this.handlerMergeResult(valueT, 'DP');
        this.handlerMergeResult(value, 'DP');
      });
    },
    /**
     * 查询D项目已部署实例的运行状态
     */
    query5GCDeployedState(qryParam = undefined) {
      const infoMap = new Map();
      infoMap.set('operation', 'dp/serviceMng/getdeployProgressInfo'); // D项目给产品下发的请求地址
      const url = `${this.url}deployed/query5GCDeployedState`;
      this.axios.post(url, infoMap).then(res => {
        const value = this.handlerResponse(res);
        // const valueT = [{ id: '11111112', status_5gc: 2 }, { id: '11111114', status_5gc: 1 }];
        // this.handlerMergeResult(valueT, '5G');
        this.handlerMergeResult(value, '5G');
      });
    },
    handlerResponse(res) {
      // console.log(res);
      if (res.status === 200) {
        const arrayVal = res.data.resultVal;
        if (arrayVal) { // 有响应结果
          try{
            EventBus.$emit('deployedProgressInfo', arrayVal, this.qryParam?this.qryParam.envID:this.qryParam, this.$refs.grid.ej2Instances.dataSource.length, 2);
          }catch(e) {
            console.log('有异常。。。。');
          }
          return arrayVal;
        }
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') })
        return null;
      }
      return null;
    },
    handlerMergeResult(res, type = undefined) {
      // console.log(res);// map集合 数据值类似{195:0}
      if (res) {
        // 更新table中运行状态
        const { grid } = this.$refs;
        if (grid === undefined) {
          return
        }
        this.$refs.grid.ej2Instances.dataSource.forEach((item) => {
          // console.log(item);
          if (res[item.id] !== undefined && res[item.id] !== '') {
            if (item.envType === '5G') {
              grid.setCellValue(item.id, 'runState', this.runstate5gMap[res[item.id]]);
              item.runState = this.runstate5gMap[res[item.id]];
              item.runStateValue = res[item.id];
            } else if(item.envType === 'DP') {
              grid.setCellValue(item.id, 'runState', this.runstateMap[res[item.id]]);
              item.runState = this.runstateMap[res[item.id]];
              item.runStateValue = res[item.id];
            }
          }
        });
        return;
        switch (type) {
          case '5G':
            this.$refs.grid.ej2Instances.dataSource.forEach((item) => {
              // this.data.forEach((item) => {
              if (item.envType === '5G') {
                const dpInfo = res.filter((item1) => item1.id === item.dpId);
                if (dpInfo && dpInfo.length > 0) {
                  item.runState = this.runstateMap[dpInfo[0].status_5gc];
                  grid.setCellValue(item.dpId, 'runState', item.runState);
                }
              }
            });
            break;
          case 'DP':
            this.$refs.grid.ej2Instances.dataSource.forEach((item) => {
            // this.data.forEach((item) => {
              if (item.envType === 'DP') {
                const dpInfo = res.filter((item1) => item1.id === item.dpId);
                if (dpInfo && dpInfo.length > 0) {
                  item.runState = this.runstateMap[dpInfo[0].status];
                  grid.setCellValue(item.dpId, 'runState', item.runState);
                }
              }
            });
            break;
          default:
            this.$refs.grid.ej2Instances.dataSource.forEach((item) => {
              // this.data.forEach((item) => {
              if (item.envType === 'DP') {
                const dpInfo = res.filter((item1) => item1.id === item.dpId);
                if (dpInfo && dpInfo.length > 0) {
                  item.runState = this.runstateMap[dpInfo[0].status];
                  grid.setCellValue(item.dpId, 'runState', item.runState);
                }
              }
            });
        }
      }
    },
    refreshData(keyword, paramName = []) {
      if (keyword === '') {
        this.$refs.grid.ej2Instances.dataSource = this.dataBak;
      } else {
        const temp = JSON.parse(JSON.stringify(this.dataBak));
        const resultTemp = [];
        temp.forEach((item) => {
          paramName.forEach((iitem) => {
            if(item[iitem] && item[iitem].toUpperCase().indexOf(keyword.toUpperCase()) > -1) {
              resultTemp.push(item);
            }
          });
        });
        console.log(resultTemp);
          // paramName.forEach((iitem) => {
          //   const tempArray = temp.filter((item) => item[iitem].toUpperCase().indexOf(keyword.toUpperCase()) > -1);
          //   if (tempArray && tempArray.length > 0) {
          //     tempArray.forEach((ii) => {
          //       resultTemp.add(temp[ii]);
          //       temp.delete()
          //     });
          //   }
        // });

        this.$refs.grid.ej2Instances.dataSource = resultTemp;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.queryAllRunStateTimer);
    clearInterval(this.query5GCRunStateTimer);
    clearInterval(this.queryDPRunStateTimer);
  },
};
</script>
